/**
 * @Description 废弃机会点提交Modal
 */
import { FC, useContext, useEffect, useMemo, useState } from 'react';
import { Modal, Form, Row, Col } from 'antd';
import V2Form from '@/common/components/Form/V2Form';
import V2FormInput from '@/common/components/Form/V2FormInput/V2FormInput';
import V2FormCascader from '@/common/components/Form/V2FormCascader/V2FormCascader';
import V2Message from '@/common/components/Others/V2Hint/V2Message';
import IconFont from '@/common/components/IconFont';
import { useMethods } from '@lhb/hook';
import { isArray, refactorSelection } from '@lhb/func';
import UserInfoContext from '@/layout/context';
import { globalAlias } from '@/common/utils/ways';
import { getChancepointSelection, chancePointRecycle } from '@/common/api/expandStore/chancepoint';
import styles from './index.module.less';

export interface ChanceDiscardData {
  id?: number;
  name?: string;
  open?: boolean;
}

export interface ChanceDiscardModalProps {
  modalData: ChanceDiscardData;
  setModalData: Function;
  onSuccess?: Function;
}

const ChanceDiscardModal: FC<ChanceDiscardModalProps> = ({
  modalData,
  setModalData,
  onSuccess, // 提交成功
}) => {
  const [isLock, setIsLock] = useState(false);
  const [recycleTypeOptions, setRecycleTypeOptions] = useState<any[]>([]);

  const [form] = Form.useForm();
  const { tenantInfo: { globalAliasItemVOs } } = useContext(UserInfoContext); // 租户信息

  const chancepointAlias = useMemo(() => {
    return globalAlias(globalAliasItemVOs);
  }, [globalAliasItemVOs]);

  useEffect(() => {
    if (!modalData.open) {
      form.resetFields();
    } else {
      form.setFieldValue('name', modalData.name);
    }
  }, [modalData.open]);

  useEffect(() => {
    getChanceOptions();
  }, []);

  /**
   * @description 获取废弃理由选项
   */
  const getChanceOptions = async () => {
    const res: any = await getChancepointSelection({}, { needCancel: false });
    const { recycleTypeList } = res || {};
    isArray(recycleTypeList) && setRecycleTypeOptions(refactorSelection(recycleTypeList, { children: 'child' }));
  };

  const methods = useMethods({
    handleClose() {
      setModalData(state => ({
        ...state,
        open: false,
      }));
    },
    handleOk() {
      if (isLock) return;
      form.validateFields().then((values) => {
        setIsLock(true);

        let params: any = {
          chancePointId: modalData.id,
        };

        const { recycleType } = values;
        if (isArray(recycleType) && recycleType.length === 2) {
          params = {
            ...params,
            firstRecycleType: recycleType[0],
            secondRecycleType: recycleType[1],
          };
        } else if (isArray(recycleType) && recycleType.length === 1) {
          params = {
            ...params,
            firstRecycleType: recycleType[0]
          };
        }

        chancePointRecycle(params).then((res) => {
          if (!res) return;
          V2Message.success({
            content: '操作成功',
          });
          onSuccess?.();
          this.handleClose();
        }).finally(() => {
          setIsLock(false);
        });
      });
    },
  });

  return (
    <Modal
      title={`废弃${chancepointAlias}`}
      open={modalData.open}
      onCancel={methods.handleClose}
      maskClosable={false}
      width={640}
      onOk={methods.handleOk}
      className={styles.discardModal}
    >
      <div className={styles.confirmInfo}>
        <IconFont iconHref='iconxq_ic_baocuo_normal' className={styles.icon}/>
        <span className={styles.text}>确认废弃该点位？后续您可以在废弃库中重新启用此点位</span>
      </div>
      <V2Form form={form}>
        <Row gutter={16}>
          <Col span={12}>
            <V2FormInput
              name='name'
              label={`${chancepointAlias}名称`}
              disabled
            />
          </Col>
          <Col span={12}>
            <V2FormCascader
              name='recycleType'
              label='废弃原因'
              required
              options={recycleTypeOptions}
            />
          </Col>
        </Row>
      </V2Form>
    </Modal>
  );
};

export default ChanceDiscardModal;
